import { JDSTooltipInternalProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSTooltipInternalProps>
  ): React.FC<JDSTooltipInternalProps> =>
  (props: JDSTooltipInternalProps) => {
    return <Component {...props} />;
  };
